import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const ValidateAccount = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('pending'); // pending | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const validate = async (token) => {
      try {
        const response = await fetch(`${import.meta.env.VITE_URL_API}/usuarios/validar-conta`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ codigo: token }),
        });
        if (response.ok) {
          setStatus('success');
          setMessage('Cadastro validado com sucesso! Agora você pode fazer login.');
        } else {
          const data = await response.json().catch(() => ({}));
          setStatus('error');
          setMessage(data?.message || 'Não foi possível validar seu cadastro. O link pode estar expirado ou já ter sido utilizado.');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Erro ao validar cadastro. Tente novamente mais tarde.');
      }
    };
    validate(token);
    console.log(token);
  }, [token]);

  // Injeta CSS no <head> apenas nesta página (escopado via [data-validate-page]) para garantir precedência dos estilos do header
  useEffect(() => {
    // Marca o <body> para que os seletores escopados atinjam o Header global
    const hadAttr = document.body.hasAttribute('data-validate-page');
    if (!hadAttr) document.body.setAttribute('data-validate-page', '');

    // Garante que o header use a variante "white" e não "transparent"
    const applyHeaderVariant = () => {
      document.querySelectorAll('.header').forEach((el) => {
        el.classList.add('white');
        el.classList.remove('transparent');
        el.classList.remove('scrolled');
      });
    };
    applyHeaderVariant();
    const mo = new MutationObserver(() => applyHeaderVariant());
    mo.observe(document.body, { childList: true, subtree: true });

    const css = `
      [data-validate-page] header,
      [data-validate-page] .header,
      [data-validate-page] .header.white,
      [data-validate-page] .header.scrolled,
      [data-validate-page] .header.transparent { background: #fff !important; box-shadow: 0 2px 4px rgba(0,0,0,0.04) !important; }
      /* Layout desejado: logo à esquerda, navegação alinhada à esquerda após logo, ações à direita */
      [data-validate-page] .header .header-content { max-width: 1200px; margin: 0 auto; padding: 12px 24px; display: flex; align-items: center; justify-content: flex-start; gap: 24px; }
      [data-validate-page] .header .logo { margin-right: 8px; }
      [data-validate-page] .header .nav-menu { flex: 0 1 auto; display: flex; justify-content: flex-start; align-items: center; }
      [data-validate-page] .header .nav-menu ul { gap: 24px; }
      [data-validate-page] .header .header-actions { margin-left: auto; display: flex; align-items: center; gap: 12px; }
      [data-validate-page] .header .logo, [data-validate-page] .header .logo * { color: #a67c52 !important; fill: #a67c52 !important; stroke: #a67c52 !important; opacity: 1 !important; filter: none !important; mix-blend-mode: normal !important; }
      [data-validate-page] .header .logo img, [data-validate-page] .header .logo svg { filter: none !important; opacity: 1 !important; }
      [data-validate-page] .header .nav-menu a, [data-validate-page] .header .nav-menu ul li a, [data-validate-page] .header .nav-menu a.active, [data-validate-page] .header .nav-menu a:hover { color: #1a1a1a !important; text-shadow: none !important; opacity: 1 !important; filter: none !important; pointer-events: auto !important; }
      [data-validate-page] .header .login-button { color: #1a1a1a !important; }
      [data-validate-page] .header .login-button:hover { color: #333 !important; }
      [data-validate-page] .header .host-button { background: #BA824F !important; color: #fff !important; border-color: #BA824F !important; }
      [data-validate-page] .header .host-button:hover { background: #a06f3f !important; }
      [data-validate-page] .header .flag-button img { filter: none !important; opacity: 1 !important; }
      [data-validate-page] .header .currency-selector button, [data-validate-page] .header .currency-selector .currency-button, [data-validate-page] .header .currency-selector *, [data-validate-page] .header .currency-select *, [data-validate-page] .header .selector-button, [data-validate-page] .header .selector-button * { color: #1a1a1a !important; fill: #1a1a1a !important; stroke: #1a1a1a !important; }
      [data-validate-page] .header .menu-toggle span { background: #333 !important; }
      [data-validate-page] .header *, [data-validate-page] .header *::before, [data-validate-page] .header *::after { text-shadow: none !important; filter: none !important; }
      [data-validate-page] .header *, [data-validate-page] .header svg *, [data-validate-page] .header .nav-menu *, [data-validate-page] .header .header-actions * { color: #1a1a1a !important; fill: currentColor !important; stroke: currentColor !important; }
      [data-validate-page] .header .host-button, [data-validate-page] .header .host-button * { color: #fff !important; fill: #fff !important; }
    `;
    const styleEl = document.createElement('style');
    styleEl.id = 'validate-account-header-override';
    styleEl.appendChild(document.createTextNode(css));
    document.head.appendChild(styleEl);
    return () => {
      try { document.head.removeChild(styleEl); } catch {}
      try { mo.disconnect(); } catch {}
      try {
        if (!hadAttr) document.body.removeAttribute('data-validate-page');
      } catch {}
    };
  }, []);

  // Ícones SVG inline para não depender de bibliotecas externas
  const icons = {
    success: (
      <svg width="64" height="64" fill="none" viewBox="0 0 24 24" style={{marginBottom:16}}>
        <circle cx="12" cy="12" r="12" fill="#e6f4ea"/>
        <path d="M8 12.5l3 3 5-5" stroke="#2e7d32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    error: (
      <svg width="64" height="64" fill="none" viewBox="0 0 24 24" style={{marginBottom:16}}>
        <circle cx="12" cy="12" r="12" fill="#fdecea"/>
        <path d="M9 9l6 6M15 9l-6 6" stroke="#c62828" strokeWidth="2.2" strokeLinecap="round"/>
      </svg>
    ),
    pending: (
      <svg width="64" height="64" fill="none" viewBox="0 0 24 24" style={{marginBottom:16, animation: 'spin 1.2s linear infinite'}}>
        <circle cx="12" cy="12" r="10" stroke="#a67c52" strokeWidth="4" opacity="0.2"/>
        <path d="M22 12a10 10 0 00-10-10" stroke="#a67c52" strokeWidth="4" strokeLinecap="round"/>
      </svg>
    )
  };

  // Estilos do card
  const cardStyle = {
    maxWidth: 420,
    margin: '90px auto',
    padding: '40px 32px 32px 32px',
    background: '#fff',
    borderRadius: 18,
    boxShadow: '0 6px 32px #34574A18',
    textAlign: 'center',
    animation: 'fadeIn 0.7s',
    border: status === 'success' ? '2px solid #2e7d32' : status === 'error' ? '2px solid #c62828' : '2px solid #a67c52',
    minHeight: 340
  };
  const titleStyle = {
    color: '#a67c52',
    marginBottom: 8,
    fontWeight: 800,
    fontSize: 28,
    letterSpacing: 0.2
  };
  const msgStyle = {
    color: status === 'success' ? '#2e7d32' : status === 'error' ? '#c62828' : '#a67c52',
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 10,
    marginTop: 0
  };
  const btnStyle = {
    display: 'inline-block',
    marginTop: 26,
    padding: '12px 34px',
    background: '#a67c52',
    color: '#fff',
    borderRadius: 8,
    textDecoration: 'none',
    fontWeight: 700,
    fontSize: 17,
    boxShadow: '0 2px 8px #a67c5212',
    border: 'none',
    transition: 'background 0.2s',
    cursor: 'pointer'
  };

  return (
    <div data-validate-page>
      <style>{`
        /* Força o header a ter fundo branco e links escuros só nesta página, independente do scroll ou variante */
        [data-validate-page] header,
        [data-validate-page] .header,
        [data-validate-page] .header.white,
        [data-validate-page] .header.scrolled,
        [data-validate-page] .header.transparent {
          background: #fff !important;
          box-shadow: 0 2px 4px rgba(0,0,0,0.04) !important;
        }
        /* Garante que o logo e ícones não fiquem esmaecidos/brancos */
        [data-validate-page] .header .logo, [data-validate-page] .header .logo * {
          color: #a67c52 !important;
          fill: #a67c52 !important;
          stroke: #a67c52 !important;
          opacity: 1 !important;
          mix-blend-mode: normal !important;
          filter: none !important;
        }
        [data-validate-page] .header .logo img, [data-validate-page] .header .logo svg {
          filter: none !important;
          opacity: 1 !important;
        }
        [data-validate-page] .header .nav-menu a,
        [data-validate-page] .header .nav-menu ul li a,
        [data-validate-page] .header .nav-menu a.active,
        [data-validate-page] .header .nav-menu a:hover {
          color: #1a1a1a !important;
          text-shadow: none !important;
          opacity: 1 !important;
          filter: none !important;
          pointer-events: auto !important;
        }
        /* Seletores de idioma/ícones no topo */
        [data-validate-page] .header .lang-switcher, [data-validate-page] .header .lang-switcher *,
        [data-validate-page] .header .top-icons, [data-validate-page] .header .top-icons * {
          color: #1a1a1a !important;
          fill: #1a1a1a !important;
          stroke: #1a1a1a !important;
          opacity: 1 !important;
          filter: none !important;
          mix-blend-mode: normal !important;
        }
        /* Botão CTA no topo (ex: Tornar-se um Anunciante) */
        [data-validate-page] .header .cta, [data-validate-page] .header .cta * {
          background: #a67c52 !important;
          color: #fff !important;
          border-color: #a67c52 !important;
          opacity: 1 !important;
          filter: none !important;
        }
        [data-validate-page] .header .nav-menu a[aria-disabled="true"],
        [data-validate-page] .header .nav-menu ul li a[aria-disabled="true"] {
          color: #ccc !important;
          opacity: 0.7 !important;
          pointer-events: none !important;
        }
        /* Ajustes para classes reais do WhiteHeader nesta rota */
        [data-validate-page] .header .login-button { color: #1a1a1a !important; }
        [data-validate-page] .header .login-button:hover { color: #333 !important; }
        [data-validate-page] .header .host-button { background: #BA824F !important; color: #fff !important; }
        [data-validate-page] .header .host-button:hover { background: #a06f3f !important; }
        [data-validate-page] .header .flag-button img { filter: none !important; opacity: 1 !important; }
        [data-validate-page] .header .currency-selector button,
        [data-validate-page] .header .currency-selector .currency-button,
        [data-validate-page] .header .currency-selector *,
        [data-validate-page] .header .currency-select *,
        [data-validate-page] .header .selector-button,
        [data-validate-page] .header .selector-button * { color: #1a1a1a !important; fill: #1a1a1a !important; stroke: #1a1a1a !important; }
        [data-validate-page] .header .menu-toggle span { background: #333 !important; }
        /* Regras de reforço (apenas nesta página) */
        [data-validate-page] .header *, [data-validate-page] .header *::before, [data-validate-page] .header *::after {
          text-shadow: none !important;
          filter: none !important;
        }
        /* Garante cores legíveis por padrão */
        [data-validate-page] .header *,
        [data-validate-page] .header svg *,
        [data-validate-page] .header .nav-menu *,
        [data-validate-page] .header .header-actions * {
          color: #1a1a1a !important;
          fill: currentColor !important;
          stroke: currentColor !important;
        }
        /* Mantém botões com suas cores próprias */
        [data-validate-page] .header .host-button, [data-validate-page] .header .host-button * { color: #fff !important; fill: #fff !important; }
        [data-validate-page] .header .login-button:hover { color: #333 !important; }
      `}</style>
      <div style={cardStyle}>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(30px);} to { opacity: 1; transform: none; } }
        @keyframes spin { 100% { transform: rotate(360deg); } }
        .validate-link:hover { background: #8d653f; }
      `}</style>
      <div>
        {status === 'pending' && icons.pending}
        {status === 'success' && icons.success}
        {status === 'error' && icons.error}
      </div>
      <div style={titleStyle}>Validação de Cadastro</div>
      <p style={msgStyle}>{
        status === 'pending' ? 'Validando seu cadastro, aguarde...' : message
      }</p>
      {status === 'success' && (
        <Link to="/login" style={btnStyle} className="validate-link">Ir para o login</Link>
      )}
      {status === 'error' && (
        <Link to="/" style={btnStyle} className="validate-link">Ir para a página inicial</Link>
      )}
    </div>
    </div>
  );
};

export default ValidateAccount;
